import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import Dropdown from "react-bootstrap/Dropdown";

import {
    get_user_all_notifications,
    user_read_notifications,
    user_all_read_notifications,
} from './notificationActions'
import { useDynamicTranslate } from "../../hooks/useDynamicTranslate";
import { useTranslation } from "react-i18next";

const NotificationHeader = () => {
    const { userallNotification, totalnotifications, notificationPayload } =
        useSelector((state) => state.notifications);
    const { user, accessToken } = useSelector((state) => state.auth);
    const { batchTranslate } = useDynamicTranslate();
    const { t, i18n } = useTranslation();
    const language = localStorage.getItem("language");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [width, setWidth] = React.useState(window.innerWidth);
    const isMobile = width <= 1000;

    React.useEffect(() => {
        const onResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    useEffect(() => {
        if (accessToken) {
            get_user_all_notifications(dispatch, batchTranslate, language);
        }
    }, [accessToken, dispatch, language]);

    const readOne = async (item) => {
        const ok = await user_read_notifications(dispatch, item?.notification_id, 2);
        if (ok === true) {
            navigate(`/auction/${item?.item_slug}`);
        }
        await get_user_all_notifications(dispatch, batchTranslate, language);
    };

    const readAll = async () => {
        await user_all_read_notifications(dispatch, 1);
        await get_user_all_notifications(dispatch, batchTranslate, language);
    };

    const goToDetail = (item) => {
        navigate(`/auction/${item?.item_slug}`);
    };

    const formatDate = (date) => {
        const now = new Date();
        const d = new Date(date);
        const diff = now - d;
        const minute = 60_000;
        const hour = minute * 60;
        const day = hour * 24;

        if (now.toDateString() === d.toDateString()) {
            if (diff < hour) {
                const m = Math.floor(diff / minute);
                // return m === 0 ? "Just now" : `${m} minute${m > 1 ? "s" : ""} ago`;
                return m === 0 ? t("notifications.justNow") : t("notifications.minutesAgo", { count: m });
            }
            const h = Math.floor(diff / hour);
            // return `${h} hour${h > 1 ? "s" : ""} ago`;
            return t("notifications.hoursAgo", { count: h });
        }
        const days = Math.ceil(diff / day);
        // return `${days} day${days > 1 ? "s" : ""} ago`;
        return t("notifications.daysAgo", { count: days });
    };

    if (!user) return null;

    return (
        <Dropdown align="end">
            <Dropdown.Toggle
                as="button"
                className="cartheader-button dropdown-toggle"
                id="notification-dropdown-toggle"
            >
                <svg className="notificationimg" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1"><path stroke-linecap="round" stroke-linejoin="round" d="M13.479 5.749A4.5 4.5 0 0 1 16.5 10v3.7l2.073 1.935a.5.5 0 0 1-.341.865H5.769a.5.5 0 0 1-.342-.866L7.5 13.7V10a4.5 4.5 0 0 1 3.021-4.251a1.5 1.5 0 0 1 2.958 0" /><path d="M10.585 18.5a1.5 1.5 0 0 0 2.83 0z" /></g></svg>
                <span className="count">
                    {notificationPayload.unSeenNotifications > 99
                        ? t("notifications.countOverflow")
                        : notificationPayload.unSeenNotifications}
                </span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="notification-item-list">
                {totalnotifications > 0 ? (
                    <>
                        <div className="mark-asread" onClick={readAll}>
                             {t("notifications.markAllAsRead")}
                        </div>
                        {userallNotification?.slice(0, 5)?.map((item, i) => (
                            <React.Fragment key={item.notification_id}>
                                <Dropdown.Item
                                    className={`dropdown-item notification-item ${item?.is_seen ? "bg-notification-seencolor" : ""
                                        }`}
                                >
                                    <div
                                        className="cart-item"
                                        // style={{ cursor: "pointer" }}
                                        // onClick={() =>
                                        //     item?.is_seen ? goToDetail(item) : readOne(item)
                                        // }
                                    >
                                        <div className="cart-item-details">
                                            <p
                                                className={`cart-item-title manage-overlap-text ${item?.is_seen
                                                    ? "notification-seencolor"
                                                    : "notification-withoutseencolor"
                                                    }`}
                                            >
                                                {item?.notification_title}
                                            </p>
                                            <p className="manage-overlap-text cart-item-price">
                                                {item?.notification_message}
                                            </p>
                                            <p className="cart-item-price">
                                                {formatDate(item?.created_at)}
                                            </p>
                                        </div>
                                    </div>
                                </Dropdown.Item>


                                {i < 4 && <div className="divide"></div>}
                            </React.Fragment>
                        ))}
                        <Dropdown.Item as="li" className="cartviewall">
                            <Link to="/notifications">{t("notifications.viewAll")}</Link>
                        </Dropdown.Item>
                    </>
                ) : (
                    <div className="text-center">
                        {t("notifications.noNotifications")}
                    </div>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default NotificationHeader;

